import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewTaxRate from "../../../../components/@tax/NewTaxRate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TaxRateNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewTaxRate
                routeType={routeType}
            />
        </SettingFrame>
    )
}       